<app-header></app-header>
<div class="container-fluid bg-refund" [style.font-family]="'var(--vex-font)'">
  <div class="container py-24">
    <p class="text-center text-5xl font-bold text-white">Enroll</p>
    <p class="pt-8 text-4xl text-center font-bold text-white">Help & Support</p>
  </div>
</div>

<div class="container-fluid mt-10 md:mt-20 px-10">
  <div class="flex">
    <!-- Sidebar with multi-menu -->
    <div class="w-1/4  p-4  shadow-md">
      <ul class="space-y-4">
        <li>
          <label (click)="toggleMenu('tab1-content')"
                 class="block text-lg font-semibold cursor-pointer hover:text-[#6752A9] transition duration-300 ">
            <span class="flex items-center">
             Introduction
            </span>
          </label>
          <ul class="pl-6 mt-2 hidden" id="tab1-content">
            <li>
              <a (click)="setActiveTab('sub-tab1')"
                 class="flex items-center py-2 text-gray-700 hover:text-[#6752A9] transition duration-300 cursor-pointer">
    <span class="mr-2" *ngIf="activeTab === 'sub-tab1'">
      <span class="block w-3 h-3 bg-[#6752A9] rounded-full"></span>
    </span>
                Meet Enroll – An Admission Management System
              </a>
            </li>

            <li><a (click)="setActiveTab('sub-tab2')"
                   class="flex items-center py-2 text-gray-700 hover:text-[#6752A9] transition duration-300 cursor-pointer">
                <span class="mr-2" *ngIf="activeTab === 'sub-tab2'">
                <span class="block w-3 h-3 bg-[#6752A9] rounded-full"></span>
              </span>Why Enroll Matters</a>
            </li>
            <li><a (click)="setActiveTab('sub-tab3')"
                   class="flex items-center py-2 text-gray-700 hover:text-[#6752A9] transition duration-300 cursor-pointer">
              <span class="mr-2" *ngIf="activeTab === 'sub-tab3'">
      <span class="block w-3 h-3 bg-[#6752A9] rounded-full"></span>
    </span>The Users – Brief of
              Roles and Responsibilities</a></li>
          </ul>
        </li>
        <li>
          <label (click)="toggleMenu('tab2-content')"
                 class="flex items-center text-lg font-semibold cursor-pointer hover:text-[#6752A9] transition duration-300 ">
            <span class="flex items-center">
         How to Login
            </span>
          </label>
          <ul class="pl-6 mt-2 hidden" id="tab2-content">
            <li><a (click)="setActiveTab('sub-tab4')"
                   class="flex items-center py-2 text-gray-700 hover:text-[#6752A9] transition duration-300 cursor-pointer">
              <span class="mr-2" *ngIf="activeTab === 'sub-tab4'">
      <span class="block w-3 h-3 bg-[#6752A9] rounded-full"></span>
    </span> How to Login</a></li>
          </ul>
        </li>
        <li>
          <label (click)="toggleMenu('tab4-content')"
                 class="block text-lg font-semibold cursor-pointer hover:text-[#6752A9] transition duration-300 ">
            <span class="flex items-center">
           Home Page
            </span>
          </label>
          <ul class="pl-6 mt-2 hidden" id="tab4-content">
            <li><a (click)="setActiveTab('sub-tab7')"
                   class="flex items-center py-2 text-gray-700 hover:text-[#6752A9] transition duration-300 cursor-pointer"><span
              class="mr-2" *ngIf="activeTab === 'sub-tab7'">
      <span class="block w-3 h-3 bg-[#6752A9] rounded-full"></span>
    </span>Page Overview</a></li>
          </ul>
        </li>
        <li>
          <label (click)="toggleMenu('tab3-content')"
                 class="flex items-center text-lg font-semibold cursor-pointer hover:text-[#6752A9] transition duration-300 ">
            <span class="flex items-center">
          Institutions
            </span>
          </label>
          <ul class="pl-6 mt-2 hidden" id="tab3-content">
            <li><a (click)="setActiveTab('sub-tab5')"
                   class="flex items-center py-2 text-gray-700 hover:text-[#6752A9] transition duration-300 cursor-pointer"><span
              class="mr-2" *ngIf="activeTab === 'sub-tab5'">
      <span class="block w-3 h-3 bg-[#6752A9] rounded-full"></span>
    </span>How to Add
              Institutions?</a></li>
            <li><a (click)="setActiveTab('sub-tab6')"
                   class="flex items-center py-2 text-gray-700 hover:text-[#6752A9] transition duration-300 cursor-pointer"><span
              class="mr-2" *ngIf="activeTab === 'sub-tab6'">
      <span class="block w-3 h-3 bg-[#6752A9] rounded-full"></span>
    </span>How to Edit, Delete,
              and mark the status as Active or Inactive?</a></li>
          </ul>
        </li>

        <li>
          <label (click)="toggleMenu('tab5-content')"
                 class="block text-lg font-semibold cursor-pointer hover:text-[#6752A9] transition duration-300 ">
            <span class="flex items-center">
          Session
            </span>
          </label>
          <ul class="pl-6 mt-2 hidden" id="tab5-content">
            <li><a (click)="setActiveTab('sub-tab8')"
                   class="flex items-center py-2 text-gray-700 hover:text-[#6752A9] transition duration-300 cursor-pointer"> <span
              class="mr-2" *ngIf="activeTab === 'sub-tab8'">
      <span class="block w-3 h-3 bg-[#6752A9] rounded-full"></span>
    </span>How to Add Session?</a>
            </li>
            <li><a (click)="setActiveTab('sub-tab9')"
                   class="flex items-center py-2 text-gray-700 hover:text-[#6752A9] transition duration-300 cursor-pointer"><span
              class="mr-2" *ngIf="activeTab === 'sub-tab9'">
      <span class="block w-3 h-3 bg-[#6752A9] rounded-full"></span>
    </span>How to update or delete
              existed session?</a></li>
            <li><a (click)="setActiveTab('sub-tab10')"
                   class="flex items-center py-2 text-gray-700 hover:text-[#6752A9] transition duration-300 cursor-pointer"><span
              class="mr-2" *ngIf="activeTab === 'sub-tab10'">
      <span class="block w-3 h-3 bg-[#6752A9] rounded-full"></span>
    </span>How to update the
              session?</a></li>
            <li><a (click)="setActiveTab('sub-tab11')"
                   class="flex items-center py-2 text-gray-700 hover:text-[#6752A9] transition duration-300 cursor-pointer"><span
              class="mr-2" *ngIf="activeTab === 'sub-tab11'">
      <span class="block w-3 h-3 bg-[#6752A9] rounded-full"></span>
    </span>How to delete or mark
              the status?</a></li>
          </ul>
        </li>
        <li>
          <label (click)="toggleMenu('tab6-content')"
                 class="block text-lg font-semibold cursor-pointer hover:text-[#6752A9] transition duration-300 ">
            <span class="flex items-center">
         Admins
            </span>
          </label>
          <ul class="pl-6 mt-2 hidden" id="tab6-content">
            <li><a (click)="setActiveTab('sub-tab12')"
                   class="flex items-center py-2 text-gray-700 hover:text-[#6752A9] transition duration-300 cursor-pointer"><span
              class="mr-2" *ngIf="activeTab === 'sub-tab12'">
      <span class="block w-3 h-3 bg-[#6752A9] rounded-full"></span>
    </span>How to Add Admins?</a>
            </li>
            <li><a (click)="setActiveTab('sub-tab13')"
                   class="flex items-center py-2 text-gray-700 hover:text-[#6752A9] transition duration-300 cursor-pointer"><span
              class="mr-2" *ngIf="activeTab === 'sub-tab13'">
      <span class="block w-3 h-3 bg-[#6752A9] rounded-full"></span>
    </span>How To Assign Institute
              to the Admin?</a></li>
            <li><a (click)="setActiveTab('sub-tab14')"
                   class="flex items-center py-2 text-gray-700 hover:text-[#6752A9] transition duration-300 cursor-pointer"><span
              class="mr-2" *ngIf="activeTab === 'sub-tab14'">
      <span class="block w-3 h-3 bg-[#6752A9] rounded-full"></span>
    </span>How to Update
              Admin?</a></li>
            <li><a (click)="setActiveTab('sub-tab15')"
                   class="flex items-center py-2 text-gray-700 hover:text-[#6752A9] transition duration-300 cursor-pointer"><span
              class="mr-2" *ngIf="activeTab === 'sub-tab15'">
      <span class="block w-3 h-3 bg-[#6752A9] rounded-full"></span>
    </span>How to change or update
              Admin’s Password?</a></li>
            <li><a (click)="setActiveTab('sub-tab16')"
                   class="flex items-center py-2 text-gray-700 hover:text-[#6752A9] transition duration-300 cursor-pointer"><span
              class="mr-2" *ngIf="activeTab === 'sub-tab16'">
      <span class="block w-3 h-3 bg-[#6752A9] rounded-full"></span>
    </span>How to mark status?</a>
            </li>
            <li><a (click)="setActiveTab('sub-tab17')"
                   class="flex items-center py-2 text-gray-700 hover:text-[#6752A9] transition duration-300 cursor-pointer"><span
              class="mr-2" *ngIf="activeTab === 'sub-tab17'">
      <span class="block w-3 h-3 bg-[#6752A9] rounded-full"></span>
    </span>How to delete
              Admin?</a></li>
          </ul>
        </li>
        <li>
          <label (click)="toggleMenu('tab7-content')"
                 class="block text-lg font-semibold cursor-pointer hover:text-[#6752A9] transition duration-300 ">
            <span class="flex items-center">
        Head Counselor
            </span>
          </label>
          <ul class="pl-6 mt-2 hidden" id="tab7-content">
            <li><a (click)="setActiveTab('sub-tab18')"
                   class="flex items-center py-2 text-gray-700 hover:text-[#6752A9] transition duration-300 cursor-pointer"><span
              class="mr-2" *ngIf="activeTab === 'sub-tab18'">
      <span class="block w-3 h-3 bg-[#6752A9] rounded-full"></span>
    </span>How to Add a Head
              Counselor?</a></li>
            <li><a (click)="setActiveTab('sub-tab19')"
                   class="flex items-center py-2 text-gray-700 hover:text-[#6752A9] transition duration-300 cursor-pointer"><span
              class="mr-2" *ngIf="activeTab === 'sub-tab19'">
      <span class="block w-3 h-3 bg-[#6752A9] rounded-full"></span>
    </span>How to update the head
              counselor’s details?</a></li>
            <li><a (click)="setActiveTab('sub-tab20')"
                   class="flex items-center py-2 text-gray-700 hover:text-[#6752A9] transition duration-300 cursor-pointer"><span
              class="mr-2" *ngIf="activeTab === 'sub-tab20'">
      <span class="block w-3 h-3 bg-[#6752A9] rounded-full"></span>
    </span>How to delete or mark
              the status of a head counselor?</a></li>
            <li><a (click)="setActiveTab('sub-tab21')"
                   class="flex items-center py-2 text-gray-700 hover:text-[#6752A9] transition duration-300 cursor-pointer"><span
              class="mr-2" *ngIf="activeTab === 'sub-tab21'">
      <span class="block w-3 h-3 bg-[#6752A9] rounded-full"></span>
    </span>How to Assign Institute
              to the Head Counselor?</a></li>
            <li><a (click)="setActiveTab('sub-tab22')"
                   class="flex items-center py-2 text-gray-700 hover:text-[#6752A9] transition duration-300 cursor-pointer"><span
              class="mr-2" *ngIf="activeTab === 'sub-tab22'">
      <span class="block w-3 h-3 bg-[#6752A9] rounded-full"></span>
    </span>Is head counselor can
              change the password?</a></li>
            <li><a (click)="setActiveTab('sub-tab23')"
                   class="flex items-center py-2 text-gray-700 hover:text-[#6752A9] transition duration-300 cursor-pointer"><span
              class="mr-2" *ngIf="activeTab === 'sub-tab23'">
      <span class="block w-3 h-3 bg-[#6752A9] rounded-full"></span>
    </span>How to check the
              sharing percentage?</a></li>
            <li><a (click)="setActiveTab('sub-tab24')"
                   class="flex items-center py-2 text-gray-700 hover:text-[#6752A9] transition duration-300 cursor-pointer"><span
              class="mr-2" *ngIf="activeTab === 'sub-tab24'">
      <span class="block w-3 h-3 bg-[#6752A9] rounded-full"></span>
    </span>How to see overall
              sharing%?</a></li>
            <li><a (click)="setActiveTab('sub-tab25')"
                   class="flex items-center py-2 text-gray-700 hover:text-[#6752A9] transition duration-300 cursor-pointer"><span
              class="mr-2" *ngIf="activeTab === 'sub-tab25'">
      <span class="block w-3 h-3 bg-[#6752A9] rounded-full"></span>
    </span>How to search for a
              particular Head counselor detail?</a></li>
          </ul>
        </li>
        <li>
          <label (click)="toggleMenu('tab8-content')"
                 class="block text-lg font-semibold cursor-pointer hover:text-[#6752A9] transition duration-300 ">
            <span class="flex items-center">
       Counselor
            </span>
          </label>
          <ul class="pl-6 mt-2 hidden" id="tab8-content">
            <li><a (click)="setActiveTab('sub-tab26')"
                   class="flex items-center py-2 text-gray-700 hover:text-[#6752A9] transition duration-300 cursor-pointer"><span
              class="mr-2" *ngIf="activeTab === 'sub-tab26'">
      <span class="block w-3 h-3 bg-[#6752A9] rounded-full"></span>
    </span>How to Add a
              Counselor?</a></li>
            <li><a (click)="setActiveTab('sub-tab27')"
                   class="flex items-center py-2 text-gray-700 hover:text-[#6752A9] transition duration-300 cursor-pointer"><span
              class="mr-2" *ngIf="activeTab === 'sub-tab27'">
      <span class="block w-3 h-3 bg-[#6752A9] rounded-full"></span>
    </span>How to update the
              counselor’s details?</a></li>
            <li><a (click)="setActiveTab('sub-tab28')"
                   class="flex items-center py-2 text-gray-700 hover:text-[#6752A9] transition duration-300 cursor-pointer"><span
              class="mr-2" *ngIf="activeTab === 'sub-tab28'">
      <span class="block w-3 h-3 bg-[#6752A9] rounded-full"></span>
    </span>How to delete or mark
              the status of a counselor?</a></li>
            <li><a (click)="setActiveTab('sub-tab29')"
                   class="flex items-center py-2 text-gray-700 hover:text-[#6752A9] transition duration-300 cursor-pointer"><span
              class="mr-2" *ngIf="activeTab === 'sub-tab29'">
      <span class="block w-3 h-3 bg-[#6752A9] rounded-full"></span>
    </span>How to Assign Institute
              to the Counselor?</a></li>
            <li><a (click)="setActiveTab('sub-tab30')"
                   class="flex items-center py-2 text-gray-700 hover:text-[#6752A9] transition duration-300 cursor-pointer"><span
              class="mr-2" *ngIf="activeTab === 'sub-tab30'">
      <span class="block w-3 h-3 bg-[#6752A9] rounded-full"></span>
    </span>Is counselor can change
              the password?</a></li>
            <li><a (click)="setActiveTab('sub-tab31')"
                   class="flex items-center py-2 text-gray-700 hover:text-[#6752A9] transition duration-300 cursor-pointer"><span
              class="mr-2" *ngIf="activeTab === 'sub-tab31'">
      <span class="block w-3 h-3 bg-[#6752A9] rounded-full"></span>
    </span>How to check the
              sharing percentage?</a></li>
            <li><a (click)="setActiveTab('sub-tab32')"
                   class="flex items-center py-2 text-gray-700 hover:text-[#6752A9] transition duration-300 cursor-pointer"><span
              class="mr-2" *ngIf="activeTab === 'sub-tab32'">
      <span class="block w-3 h-3 bg-[#6752A9] rounded-full"></span>
    </span>How to see overall
              sharing%?</a></li>
            <li><a (click)="setActiveTab('sub-tab33')"
                   class="flex items-center py-2 text-gray-700 hover:text-[#6752A9] transition duration-300 cursor-pointer"><span
              class="mr-2" *ngIf="activeTab === 'sub-tab33'">
      <span class="block w-3 h-3 bg-[#6752A9] rounded-full"></span>
    </span>How to search for a
              particular counselor detail?</a></li>
          </ul>
        </li>
        <li>
          <label (click)="toggleMenu('tab9-content')"
                 class="block text-lg font-semibold cursor-pointer hover:text-[#6752A9] transition duration-300 ">
            <span class="flex items-center">
       Modules
            </span>
          </label>
          <ul class="pl-6 mt-2 hidden" id="tab9-content">
            <li><a (click)="setActiveTab('sub-tab34')"
                   class="flex items-center py-2 text-gray-700 hover:text-[#6752A9] transition duration-300 cursor-pointer"><span
              class="mr-2" *ngIf="activeTab === 'sub-tab34'">
      <span class="block w-3 h-3 bg-[#6752A9] rounded-full"></span>
    </span>Program</a></li>
            <li><a (click)="setActiveTab('sub-tab35')"
                   class="flex items-center py-2 text-gray-700 hover:text-[#6752A9] transition duration-300 cursor-pointer"><span
              class="mr-2" *ngIf="activeTab === 'sub-tab35'">
      <span class="block w-3 h-3 bg-[#6752A9] rounded-full"></span>
    </span>Courses</a></li>
            <li><a (click)="setActiveTab('sub-tab36')"
                   class="flex items-center py-2 text-gray-700 hover:text-[#6752A9] transition duration-300 cursor-pointer"><span
              class="mr-2" *ngIf="activeTab === 'sub-tab36'">
      <span class="block w-3 h-3 bg-[#6752A9] rounded-full"></span>
    </span>Branches</a></li>
            <li><a (click)="setActiveTab('sub-tab37')"
                   class="flex items-center py-2 text-gray-700 hover:text-[#6752A9] transition duration-300 cursor-pointer"><span
              class="mr-2" *ngIf="activeTab === 'sub-tab37'">
      <span class="block w-3 h-3 bg-[#6752A9] rounded-full"></span>
    </span>Mappings</a></li>
          </ul>
        </li>
        <li>
          <label (click)="toggleMenu('tab10-content')"
                 class="block text-lg font-semibold cursor-pointer hover:text-[#6752A9] transition duration-300 ">
            <span class="flex items-center">
       Phases
            </span>
          </label>
          <ul class="pl-6 mt-2 hidden" id="tab10-content">
            <li><a (click)="setActiveTab('sub-tab38')"
                   class="flex items-center py-2 text-gray-700 hover:text-[#6752A9] transition duration-300 cursor-pointer"><span
              class="mr-2" *ngIf="activeTab === 'sub-tab38'">
      <span class="block w-3 h-3 bg-[#6752A9] rounded-full"></span>
    </span>Stages</a></li>
            <li><a (click)="setActiveTab('sub-tab39')"
                   class="flex items-center py-2 text-gray-700 hover:text-[#6752A9] transition duration-300 cursor-pointer"><span
              class="mr-2" *ngIf="activeTab === 'sub-tab39'">
      <span class="block w-3 h-3 bg-[#6752A9] rounded-full"></span>
    </span>Reason</a></li>
            <li><a (click)="setActiveTab('sub-tab40')"
                   class="flex items-center py-2 text-gray-700 hover:text-[#6752A9] transition duration-300 cursor-pointer"><span
              class="mr-2" *ngIf="activeTab === 'sub-tab40'">
      <span class="block w-3 h-3 bg-[#6752A9] rounded-full"></span>
    </span>Mappings</a></li>
          </ul>
        </li>
        <li>
          <label (click)="toggleMenu('tab11-content')"
                 class="block text-lg font-semibold cursor-pointer hover:text-[#6752A9] transition duration-300 ">
            <span class="flex items-center">
     Leads
            </span>
          </label>
          <ul class="pl-6 mt-2 hidden" id="tab11-content">
            <li><a (click)="setActiveTab('sub-tab41')"
                   class="flex items-center py-2 text-gray-700 hover:text-[#6752A9] transition duration-300 cursor-pointer"><span
              class="mr-2" *ngIf="activeTab === 'sub-tab41'">
      <span class="block w-3 h-3 bg-[#6752A9] rounded-full"></span>
    </span>Manual Leads</a></li>
            <li><a (click)="setActiveTab('sub-tab42')"
                   class="flex items-center py-2 text-gray-700 hover:text-[#6752A9] transition duration-300 cursor-pointer"><span
              class="mr-2" *ngIf="activeTab === 'sub-tab42'">
      <span class="block w-3 h-3 bg-[#6752A9] rounded-full"></span>
    </span>Facebook Leads</a></li>
            <li><a (click)="setActiveTab('sub-tab43')"
                   class="flex items-center py-2 text-gray-700 hover:text-[#6752A9] transition duration-300 cursor-pointer"><span
              class="mr-2" *ngIf="activeTab === 'sub-tab43'">
      <span class="block w-3 h-3 bg-[#6752A9] rounded-full"></span>
    </span>Messenger Leads</a>
            </li>
            <li><a (click)="setActiveTab('sub-tab44')"
                   class="flex items-center py-2 text-gray-700 hover:text-[#6752A9] transition duration-300 cursor-pointer"><span
              class="mr-2" *ngIf="activeTab === 'sub-tab44'">
      <span class="block w-3 h-3 bg-[#6752A9] rounded-full"></span>
    </span>Instagram Leads</a>
            </li>
            <li><a (click)="setActiveTab('sub-tab45')"
                   class="flex items-center py-2 text-gray-700 hover:text-[#6752A9] transition duration-300 cursor-pointer"><span
              class="mr-2" *ngIf="activeTab === 'sub-tab45'">
      <span class="block w-3 h-3 bg-[#6752A9] rounded-full"></span>
    </span>Report</a></li>
          </ul>
        </li>
        <li>
          <label (click)="toggleMenu('tab12-content')"
                 class="block text-lg font-semibold cursor-pointer hover:text-[#6752A9] transition duration-300 ">
            <span class="flex items-center">
     Student
            </span>
          </label>
          <ul class="pl-6 mt-2 hidden" id="tab12-content">
            <li><a (click)="setActiveTab('sub-tab46')"
                   class="flex items-center py-2 text-gray-700 hover:text-[#6752A9] transition duration-300 cursor-pointer"><span
              class="mr-2" *ngIf="activeTab === 'sub-tab46'">
      <span class="block w-3 h-3 bg-[#6752A9] rounded-full"></span>
    </span>Add Students</a></li>
            <li><a (click)="setActiveTab('sub-tab47')"
                   class="flex items-center py-2 text-gray-700 hover:text-[#6752A9] transition duration-300 cursor-pointer"><span
              class="mr-2" *ngIf="activeTab === 'sub-tab47'">
      <span class="block w-3 h-3 bg-[#6752A9] rounded-full"></span>
    </span>Students
              Verification</a></li>
            <li><a (click)="setActiveTab('sub-tab48')"
                   class="flex items-center py-2 text-gray-700 hover:text-[#6752A9] transition duration-300 cursor-pointer"><span
              class="mr-2" *ngIf="activeTab === 'sub-tab48'">
      <span class="block w-3 h-3 bg-[#6752A9] rounded-full"></span>
    </span>Process Head
              Counselor’s Students</a></li>
            <li><a (click)="setActiveTab('sub-tab49')"
                   class="flex items-center py-2 text-gray-700 hover:text-[#6752A9] transition duration-300 cursor-pointer"><span
              class="mr-2" *ngIf="activeTab === 'sub-tab49'">
      <span class="block w-3 h-3 bg-[#6752A9] rounded-full"></span>
    </span>Process Counselor’s
              Students</a></li>
            <li><a (click)="setActiveTab('sub-tab50')"
                   class="flex items-center py-2 text-gray-700 hover:text-[#6752A9] transition duration-300 cursor-pointer"><span
              class="mr-2" *ngIf="activeTab === 'sub-tab50'">
      <span class="block w-3 h-3 bg-[#6752A9] rounded-full"></span>
    </span>All Students</a></li>
          </ul>
        </li>
        <li>
          <label (click)="toggleMenu('tab13-content')"
                 class="block text-lg font-semibold cursor-pointer hover:text-[#6752A9] transition duration-300 ">
            <span class="flex items-center">
     Accounts
            </span>
          </label>
          <ul class="pl-6 mt-2 hidden" id="tab13-content">
            <li><a (click)="setActiveTab('sub-tab51')"
                   class="flex items-center py-2 text-gray-700 hover:text-[#6752A9] transition duration-300 cursor-pointer"><span
              class="mr-2" *ngIf="activeTab === 'sub-tab51'">
      <span class="block w-3 h-3 bg-[#6752A9] rounded-full"></span>
    </span>Process Transaction</a>
            </li>
            <li><a (click)="setActiveTab('sub-tab52')"
                   class="flex items-center py-2 text-gray-700 hover:text-[#6752A9] transition duration-300 cursor-pointer"><span
              class="mr-2" *ngIf="activeTab === 'sub-tab52'">
      <span class="block w-3 h-3 bg-[#6752A9] rounded-full"></span>
    </span>Receipt Transaction</a>
            </li>
            <li><a (click)="setActiveTab('sub-tab53')"
                   class="flex items-center py-2 text-gray-700 hover:text-[#6752A9] transition duration-300 cursor-pointer"><span
              class="mr-2" *ngIf="activeTab === 'sub-tab53'">
      <span class="block w-3 h-3 bg-[#6752A9] rounded-full"></span>
    </span>Reports</a></li>
          </ul>
        </li>
        <li>
          <label (click)="toggleMenu('tab14-content')"
                 class="block text-lg font-semibold cursor-pointer hover:text-[#6752A9] transition duration-300 ">
            <span class="flex items-center">
    Receipts
            </span>
          </label>
          <ul class="pl-6 mt-2 hidden" id="tab14-content">
            <li><a (click)="setActiveTab('sub-tab54')"
                   class="flex items-center py-2 text-gray-700 hover:text-[#6752A9] transition duration-300 cursor-pointer"><span
              class="mr-2" *ngIf="activeTab === 'sub-tab54'">
      <span class="block w-3 h-3 bg-[#6752A9] rounded-full"></span>
    </span>How to Add a
              receipt?</a></li>
            <li><a (click)="setActiveTab('sub-tab55')"
                   class="flex items-center py-2 text-gray-700 hover:text-[#6752A9] transition duration-300 cursor-pointer"><span
              class="mr-2" *ngIf="activeTab === 'sub-tab55'">
      <span class="block w-3 h-3 bg-[#6752A9] rounded-full"></span>
    </span>List</a></li>
            <li><a (click)="setActiveTab('sub-tab56')"
                   class="flex items-center py-2 text-gray-700 hover:text-[#6752A9] transition duration-300 cursor-pointer"><span
              class="mr-2" *ngIf="activeTab === 'sub-tab56'">
      <span class="block w-3 h-3 bg-[#6752A9] rounded-full"></span>
    </span>Counselor receipt</a>
            </li>
          </ul>
        </li>
        <li>
          <label (click)="toggleMenu('tab15-content')"
                 class="block text-lg font-semibold cursor-pointer hover:text-[#6752A9] transition duration-300 ">
            <span class="flex items-center">
   Tickets
            </span>
          </label>
          <ul class="pl-6 mt-2 hidden" id="tab15-content">
            <li><a (click)="setActiveTab('sub-tab57')"
                   class="flex items-center py-2 text-gray-700 hover:text-[#6752A9] transition duration-300 cursor-pointer"><span
              class="mr-2" *ngIf="activeTab === 'sub-tab57'">
      <span class="block w-3 h-3 bg-[#6752A9] rounded-full"></span>
    </span>Admission Tickets</a>
            </li>
            <li><a (click)="setActiveTab('sub-tab58')"
                   class="flex items-center py-2 text-gray-700 hover:text-[#6752A9] transition duration-300 cursor-pointer"><span
              class="mr-2" *ngIf="activeTab === 'sub-tab58'">
      <span class="block w-3 h-3 bg-[#6752A9] rounded-full"></span>
    </span>Leads Tickets</a></li>
            <li><a (click)="setActiveTab('sub-tab59')"
                   class="flex items-center py-2 text-gray-700 hover:text-[#6752A9] transition duration-300 cursor-pointer"><span
              class="mr-2" *ngIf="activeTab === 'sub-tab59'">
      <span class="block w-3 h-3 bg-[#6752A9] rounded-full"></span>
    </span>Others Tickets</a></li>
          </ul>
        </li>
        <li>
          <label (click)="toggleMenu('tab16-content')"
                 class="block text-lg font-semibold cursor-pointer hover:text-[#6752A9] transition duration-300 ">
            <span class="flex items-center">
   Notifications
            </span>
          </label>
          <ul class="pl-6 mt-2 hidden" id="tab16-content">
            <li><a (click)="setActiveTab('sub-tab60')"
                   class="flex items-center py-2 text-gray-700 hover:text-[#6752A9] transition duration-300 cursor-pointer"><span
              class="mr-2" *ngIf="activeTab === 'sub-tab60'">
      <span class="block w-3 h-3 bg-[#6752A9] rounded-full"></span>
    </span>Add Notifications</a>
            </li>
            <li><a (click)="setActiveTab('sub-tab61')"
                   class="flex items-center py-2 text-gray-700 hover:text-[#6752A9] transition duration-300 cursor-pointer"><span
              class="mr-2" *ngIf="activeTab === 'sub-tab61'">
      <span class="block w-3 h-3 bg-[#6752A9] rounded-full"></span>
    </span>Check Notification</a>
            </li>
          </ul>
        </li>
      </ul>
    </div>

    <!-- Content Area -->
    <div class="w-3/4 p-8 bg-white rounded-lg shadow-md">
      <div *ngIf="activeTab === 'sub-tab1'" class="animate-fade-in">
        <h2 class="text-2xl font-semibold mb-4">Meet Enroll – An Admission Management System</h2>
        <p class="text-lg mb-4 text-justify">
          Enroll is one-of-a-kind software that transforms the enrollment process with this
          cutting-edge Admission Management System that streamlines students’ workflow
          and admission process with ease of technology and innovation. Through the
          software, the different kinds of users can work together under one roof that
          eliminate any kind of miscommunication.
        </p>
        <p class="text-lg mb-4 text-justify">
          Through the software, the organization can manage multiple- universities at a time.
          It can oversee and control various admission processes such as students’ modules,
          phases, leads management, accounts and finance, communication, notifications,
          and many more. Moreover, Enroll ensures the authenticity of the workflow and
          creates the best user journey by providing different kinds of roles, responsibilities,
          and authority to the respective users. Here is a brief description of the users and
          their work.
        </p>
      </div>
      <div *ngIf="activeTab === 'sub-tab2'" class="animate-fade-in">
        <h2 class="text-2xl font-semibold mb-4">Why Enroll Matters</h2>
        <p class="text-lg mb-4 text-justify">
          Enroll is a game-changing software that redefines the enrollment process with its
          state-of-the-art Admission Management System. By seamlessly integratingtechnology and innovation, Enroll
          simplifies the workflow for students and
          streamlines admissions with unparalleled ease. Its unified platform fosters
          collaboration among diverse users, ensuring smooth communication and
          eliminating missteps. With Enroll, experience a new era of efficiency and harmony
          in managing admissions.
        </p>
      </div>
      <div *ngIf="activeTab === 'sub-tab3'" class="animate-fade-in">
        <h2 class="text-2xl font-semibold mb-4">The Users – Brief of Roles and Responsibilities</h2>
        <p class="text-lg mb-4 text-justify">
          <span class="text-bold"> Enroll software Allows four kinds of users:</span> Organization, Admins, Head
          Counselor, and Counselor
        </p>
        <p class="text-lg mb-4 text-justify">
          <span class="text-bold">Organization – </span>The organization is the most superior user of the portal. It has
          the
          authority to add institutions, add and assign admins to the respective institution,
          add sessions, send notifications, and oversee the complete admission journey.
        </p>
        <p class="text-lg mb-4 text-justify">
          <span class="text-bold"> Admins – </span> Admins are added and managed by institutions or organizations. They
          are responsible for managing overall system settings and administrative tasks for
          fluent enrollment. They have the authority to add head counselors and counselors
          under their supervision. Moreover, they can add or manage sections such as
          Modules, Phases, leads, Students, Accounts, Receipts, Tickets, and Notifications.
        </p>
        <p class="text-lg mb-4 text-justify">
          <span class="text-bold"> Head Counselors – </span> Head Counselors can be added and assigned institutions by
          the
          admins. They oversee counseling activities and students’ guidance process. They
          have the authority to add and assign counselors and manage them under their roof.
          Moreover, they can add and manage students’ data, leads, and oversee accounts,
          tickets, receipts, and notifications.
        </p>
        <p class="text-lg mb-4 text-justify">
          <span class="text-bold"> Counselor – </span> Counselors provide direct support to the students and maintain
          student records. They have limited access such as adding student data and manual
          leads.
        </p>
        <p class="text-lg mb-4 text-justify">
          Without wasting much time, let’s dive into the software and check out how it
          works!
        </p>
      </div>
      <div *ngIf="activeTab === 'sub-tab4'" class="animate-fade-in">
        <h2 class="text-2xl font-semibold mb-4">How To Login?</h2>
        <p class="text-lg mb-4 text-justify">
          Login to the Enroll software to jump into the software for an effortless admission
          enrollment process.
        </p>
        <ol class="list-decimal  text-lg pl-2">
          <li>Click on the User Register account available on the Screen in the Upper right corner</li>
          <li>Choose the Institutions from the scroller</li>
          <li>Fill out the username</li>
          <li>Fill Password</li>
          <li>Click on submit and you will be directed to the Enroll Dashboard</li>
        </ol>
        <img src="" alt="dashboard image">
        <p class="text-lg mb-4 text-justify">
          The Dashboard provides a precise overview of the entire software such as several
          institutions, total admins, head counselors, and counselors. By scrolling below,
          sales reports, leads, session reports, student personal information, account details,
          etc. can be seen here. To customize your search, choose the preferred institution by
          using the filter available at the upper right corner of the screen.
        </p>
      </div>
      <div *ngIf="activeTab === 'sub-tab5'" class="animate-fade-in">
        <h2 class="text-2xl font-semibold mb-4">Institutions – Roles and Responsibilities</h2>
        <p class="text-lg mb-4 text-justify">
          Institutions are the educational landscape through which students accomplish their
          study goals. The organizations can add multiple institutions, admins and create
          sessions for a smooth student journey. They can assign a particular institute to the
          respective admins to hold and manage the entire admission process.
        </p>
        <p class="text-lg mb-4 text-justify">
          Get details for the Total Number of Institutions, Admin Assigned Institutions,
          Active Institutions, and Inactive Institutions. Additionally, institution details such
          as Name, Code, Prefix, State, Zip Code, and Status can be seen here. Also, the tab
          allows you to get an overview of Institution wise admission analytics.
        </p>
        <h2 class="text-2xl font-semibold mb-4">How to Add Institutions?</h2>
        <p class="text-lg mb-4 text-justify">
          Institutions can be added or assigned by the organization only. Here are the steps to Add institutions:
        </p>
        <ol class="list-decimal  text-lg pl-2">
          <li>Click on the Institutions tab</li>
          <li>Click on the Add tab and fill out the details such as institution name, Code, Type, Prefix, and complete
            address.
          </li>
          <li>Click on the Submit button available lower right side of the screen.</li>
          <li>If you want to change or make corrections, click on the Reset tab available at the lower left side of the
            screen.
          </li>
        </ol>
      </div>
      <div *ngIf="activeTab === 'sub-tab6'" class="animate-fade-in">
        <h2 class="text-2xl font-semibold mb-4">How to Edit, Delete, and mark the status as Active or Inactive?</h2>
        <p class="text-lg mb-4 text-justify">
          Once the institution has been added, the user can go through the details under the List.
        </p>
        <p class="text-lg mb-4 text-justify">
          <span class="text-bold"> To Edit information – </span> To edit the institution details, click on the Edit key
          available on the right side, fill in the details, and submit the information.
        </p>
        <p class="text-lg mb-4 text-justify">
          <span class="text-bold"> To Mark Status – </span> To mark the institute as Active or Inactive, click on the
          Lock key on the right side, fill in the details, and submit the information.
        </p>
        <p class="text-lg mb-4 text-justify">
          <span class="text-bold"> To Delete – </span> To delete the institute, click on the Bin key on the right side
          and remove the information.
        </p>
        <p class="text-md mb-4 text-justify">
          <span class="text-bold"> Note:  </span> If the organization wants to delete or inactive any institute, that
          particular institute should not have active head counselors, counselors, and students.
        </p>
        <p class="text-lg mb-4 text-justify">
          <span class="text-bold">Search –  </span> The user can use the search bar for the personalized view by filling
          out the institute name/code/prefix.
        </p>
      </div>
      <div *ngIf="activeTab === 'sub-tab7'" class="animate-fade-in">
        <h2 class="text-2xl font-semibold mb-4">Home Page Overview</h2>
        <ul class="list-disc text-lg">
          <li>The home page provides a precise view of your portal that includes the data
            in the form of graphs and numbers. The very first view will be the Account
            overview which can be filtered with the customized date and time to go
            through the details of Total Institutions, Total Admins, Total Head
            Counselor, and Total Counselor.
          </li>
          <li>By enrolling below, you can be able to find the sales report such as Total
            Manual Leads, and Total Social Media Leads.
          </li>
          <li>After that, the Session report will appear and the user will get an overview of
            the Session Reports. Additionally, they can filter the result by choosing the
            Session year for the particular information. The portal will provide
            information such as Student Name, Father Name, Mother Name, and Course
            Name.
          </li>
          <li>Last but not the least, Amount. Through the section, users including the
            admin, head counselor, or counselor can see the account details such as Total
            Credit Amount and Total Debited Amount.
          </li>
        </ul>
      </div>
      <div *ngIf="activeTab === 'sub-tab8'" class="animate-fade-in">
        <h2 class="text-2xl font-semibold mb-4">Session</h2>
        <p class="text-lg mb-4 text-justify">
          Sessions are predefined periods or academic years used to categorize and manage student enrollment and
          progress data. The organizations have the authority to add sessions for the particular institute and tenure.
          The page provides basic details such as Total Sessions, Default Sessions, Active Sessions, and Inactive
          Sessions. Graphs involve Sessions and Session wise admissions details. Let’s check how it works.
        </p>
        <h2 class="text-2xl font-semibold mb-4">How to Add Session</h2>
        <ol class="list-decimal text-lg pl-2">
          <li> Click on the Add tab under the Session section</li>
          <li>Fill out the details including session name, year, application ID prefix, and pro-ID prefix</li>
          <li>Click on submit and you have created a session successfully</li>
        </ol>
      </div>
      <div *ngIf="activeTab === 'sub-tab9'" class="animate-fade-in">
        <h2 class="text-2xl font-semibold mb-4">How to update or delete existed session?</h2>
        <p class="text-lg mb-4 text-justify">
          Once, you have created the session successfully, it will be visible under the list automatically. The list
          contains a precise view of your existing session. Through the list, one can update or delete the preferred
          session.
        </p>
      </div>
      <div *ngIf="activeTab === 'sub-tab10'" class="animate-fade-in">
        <h2 class="text-2xl font-semibold mb-4">How to update the session?</h2>
        <ol class="list-decimal text-lg pl-2">
          <li>Click on the edit key available in the session row</li>
          <li>Fill out the details such as name or year etc.</li>
          <li>Submit the information or reset if change required</li>
        </ol>
      </div>
      <div *ngIf="activeTab === 'sub-tab11'" class="animate-fade-in">
        <h2 class="text-2xl font-semibold mb-4">How to delete or mark the status?</h2>
        <p class="text-lg mb-4 text-justify">
          The organizations have the authority to delete the session or mark their status as Active or Inactive.
        </p>
        <ol class="list-decimal text-lg pl-2">
          <li>Click on the Bin key (For delete) or Lock key (Status – Active or Inactive) available in the session’s
            row
          </li>
          <li>Save the information</li>
        </ol>
        <p class="text-md mb-4 text-justify">
          <span>Note: </span> If the organization wants to delete or inactive any session, that particular session
          should not have students.
        </p>
        <p class="text-md mb-4 text-justify">
          The organization should mark at least one session as inactive and one session should be marked active and
          can’t be deleted or inactive.
        </p>
      </div>

      <div *ngIf="activeTab === 'sub-tab12'" class="animate-fade-in">
        <h2 class="text-2xl font-semibold mb-4">Admin Roles & Responsibilities</h2>
        <p class="text-lg mb-4 text-justify">Admins can be added and assigned institutions by the Organization. Admins
          are managed and oversee the overall
          admission process to create a hassle-free enrollment. They have head counselors and counselors under their
          supervision. Also, Admins have the authority to add modules (Programs, Courses, and Branches), manage leads,
          assign institutions to the counselors, accounts, and finance, and create and manage receipts and
          notifications. </p>
        <p class="text-lg mb-4 text-justify">Admins details include Total Admins, Institution Assigned Admins, Active
          Admins, and Inactive Admins. Also, the user can see Admins details such as Name, Email, Contact, Joined Date,
          and Status. The details in the form of graphs that emphasize Admin wise admissions and Admin wise institutions
          can be seen.</p>
        <h2 class="text-2xl font-semibold mb-4">How to Add Admins?</h2>
        <ol class="list-decimal text-lg pl-2">
          <li>Click on the Add tab under the admins</li>
          <li>Fill out the admin’s details such as name, email, contact number, user name, and password.</li>
          <li>Click on Submit available at the lower right corner and lock the information.</li>
          <li>To change or make corrections, click on the Reset tab available at the lower left corner</li>
        </ol>
      </div>

      <div *ngIf="activeTab === 'sub-tab13'" class="animate-fade-in">
        <h2 class="text-2xl font-semibold mb-4">How To Assign Institute to the Admin by Organization?</h2>
        <p class="text-lg mb-4 text-justify">To assign the institute, the user needs to go to List. Once, the admin is
          added, it will automatically list on the portal from where the user can edit, update, and delete the
          information.
        </p>
        <ol class="list-decimal text-lg pl-2">
          <li> Click on the Assign Institute tab available in the admin’s row</li>
          <li> Choose the institute for the admin by making the tab green</li>
          <li>Click on the Assign Institute tab available at the lower right corner of the table</li>
        </ol>
      </div>

      <div *ngIf="activeTab === 'sub-tab14'" class="animate-fade-in">
        <h2 class="text-2xl font-semibold mb-4">How to Update Admin?</h2>
        <ol class="list-decimal text-lg pl-2">
          <li>Click on the update key available on the right side</li>
          <li>Fill out the updated details of the admin</li>
          <li>Click Update and save the information</li>
          <li>To make changes use the Reset tab available at the lower left corner.</li>
        </ol>
      </div>

      <div *ngIf="activeTab === 'sub-tab15'" class="animate-fade-in">
        <h2 class="text-2xl font-semibold mb-4">How to change or update Admin’s Password?</h2>
        <p class="text-justify mb-4 text-lg">Admin or organization can change the password for the particular user.</p>
        <ol class="list-decimal text-lg pl-2">
          <li>Click on the Key tab available in the row</li>
          <li>Fill in new passwords and click on the update password tab</li>
        </ol>
      </div>

      <div *ngIf="activeTab === 'sub-tab16'" class="animate-fade-in">
        <h2 class="text-2xl font-semibold mb-4">How to mark status?</h2>
        <ol class="list-decimal text-lg pl-2">
          <li>Click on the Lock tab available in the Admins row</li>
          <li>Click the tab to update status as Active or Inactive</li>
        </ol>
      </div>

      <div *ngIf="activeTab === 'sub-tab17'" class="animate-fade-in">
        <h2 class="text-2xl font-semibold mb-4">How to delete Admin?</h2>
        <ol class="list-decimal text-lg pl-2 mb-4">
          <li>Click on the bin tab available in the admin’s row</li>
          <li> Remove the admin</li>
        </ol>
        <p class="text-md mb-4 text-justify">
          <span class="text-bold"> Note: </span> To delete Admin, the organization should make sure that there are no
          active head counselors or counselors under their supervision.
        </p>
      </div>

      <div *ngIf="activeTab === 'sub-tab18'" class="animate-fade-in">
        <h2 class="text-2xl font-semibold mb-4">Head Counselor: The Roles and Responsibilities</h2>
        <p class="text-justify mb-4 text-lg">Head Counselors manage the entire admission process and counseling
          activities under the supervision of
          Admins. The user can check the head counselor's detailed overview that includes the Total Head Counselor, Head
          Counselor Assigned Institutions, Active Head Counselors, and Inactive Head Counselors. Also, the precise view
          of head counselors such as Name, Address, Email, contact, and status can be seen here along with the graphs
          that show the Head Counselor admission analytics and the Head Counselor's session-wise sharing
          percentage.<br />
          They are added and assigned institutions by the admins and have counselors under their roof. Wondering how?
          Let’s see
        </p>
        <h2 class="text-2xl font-semibold mb-4">How to Add a Head Counselor</h2>
        <ol class="list-decimal text-lg pl-2">
          <li> Click on the tab Add available only for Admins</li>
          <li>Fill out the details including Name, Username, Address, Email, and Contact, and assign the institute</li>
          <li>Click on Submit available at the lower right corner and lock the information.</li>
          <li>To change or make corrections, click on the Reset tab available at the lower left corner</li>
        </ol>
      </div>

      <div *ngIf="activeTab === 'sub-tab19'" class="animate-fade-in">
        <h2 class="text-2xl font-semibold mb-4">How to update the head counselor’s details?</h2>
        <p class="text-justify mb-4 text-lg">Once, the head counselor’s details are added successfully, they will be
          visible in the List section automatically from where the User or Admin can edit or update the details
          easily.</p>
        <h2 class="text-2xl font-semibold mb-4">To update the head counselor's details</h2>
        <ol class="list-decimal text-lg pl-2">
          <li>Click on the edit key available in the head counselor’s row</li>
          <li>Fill out the details required</li>
          <li>Click on submit and save the information</li>
        </ol>
      </div>

      <div *ngIf="activeTab === 'sub-tab20'" class="animate-fade-in">
        <h2 class="text-2xl font-semibold mb-4">How to delete or mark the status of a head counselor?</h2>
        <p class="text-justify mb-4 text-lg">Admins have the authority to delete the counselor or mark their status as
          Active or Inactive.</p>
        <ol class="list-decimal text-lg pl-2 mb-4">
          <li>Click on the Bin key (For delete) or Lock key (Status – Active or Inactive) available in the counselor’s
            row
          </li>
          <li>Save the information</li>
        </ol>
        <p class="text-md mb-4 text-justify">
          <span class="text-bold"> Note:  </span> If the organization wants to delete or inactive any institute, that
          particular institute should not have active head counselors, counselors, and students.
        </p>
      </div>

      <div *ngIf="activeTab === 'sub-tab21'" class="animate-fade-in">
        <h2 class="text-2xl font-semibold mb-4">How to Assign Institute to the Head Counselor?</h2>
        <ol class="list-decimal text-lg pl-2 mb-4">
          <li>Click on Assign Institutions tab available in the row</li>
          <li>Choose the institutions for the head counselor from the list created already</li>
        </ol>
      </div>

      <div *ngIf="activeTab === 'sub-tab22'" class="animate-fade-in">
        <h2 class="text-2xl font-semibold mb-4">Is head counselor can change the password?</h2>
        <p class="text-justify text-lg mb-4">Yes, by following the below-mentioned simple steps, the head counselors or
          admins can change or create a new password.</p>
        <ol class="list-decimal text-lg pl-2 mb-4">
          <li>Go to the key tab and click</li>
          <li>Fill out the new password and save the information</li>
        </ol>
      </div>

      <div *ngIf="activeTab === 'sub-tab23'" class="animate-fade-in">
        <h2 class="text-2xl font-semibold mb-4">How to check the sharing percentage?</h2>
        <p class="text-justify text-lg mb-4">Through the tab Sharing, the user or Admin can check or add the amount of
          commission available for admission to the head counselors.</p>
        <ol class="list-decimal text-lg pl-2 mb-4">
          <li>Click on Sharing% tab</li>
          <li>The details about the amount can be seen along with the status as pending or assigned</li>
        </ol>
      </div>

      <div *ngIf="activeTab === 'sub-tab24'" class="animate-fade-in">
        <h2 class="text-2xl font-semibold mb-4">How to see overall sharing%?</h2>
        <p class="text-justify text-lg mb-4">The wallet amount for head counselors can be added by Admins. Moreover,
          Admins can allow the enrollment sharing% to the head counselors via two methods; Overall sharing and fee
          structure sharing</p>
        <p class="text-justify text-lg"><span class="font-semibold">Overall Sharing:</span>The term refers to the
          lump sum amount assigned by the Admins for the student enrollment to the head counselors.</p>
        <p class="text-justify text-lg mb-4"><span class="font-semibold">Fee Structure:</span>The term describes the
          commission for admission following each step mentioned- below to the head counselor by admins.</p>
        <ol class="list-decimal text-lg pl-2 mb-4">
          <li>Click on the sharing tab mentioned in the head counselor row</li>
          <li>Fill out the details such as including fee structure, registration fee, course fee, re-registration fee,
            and click on Assign sharing.
          </li>
        </ol>
      </div>

      <div *ngIf="activeTab === 'sub-tab25'" class="animate-fade-in">
        <h2 class="text-2xl font-semibold mb-4">How to search for a particular Head counselor detail?</h2>
        <p class="text-justify text-lg mb-4">If you wish to check the details for a particular head counselor, the
          search tab will help you to customize the information. Check out how.</p>
        <ol class="list-decimal text-lg pl-2 mb-4">
          <li>Choose the institute or session with the filter available at the upper right corner</li>
          <li>Fill in the detail’s Program/Course/branch</li>
          <li>Click on the Search tab and see the personalized information</li>
        </ol>
      </div>

      <div *ngIf="activeTab === 'sub-tab26'" class="animate-fade-in">
        <h2 class="text-2xl font-semibold mb-4">Counselor: The Roles and Responsibilities</h2>
        <p class="text-justify text-lg mb-4">The Counselors provide direct support and manage student data under the
          supervision of Head Counselors. The user can check the counselor's detailed overview that includes Total
          Counselor, Counselor Assigned Institutions, Active Counselors, and Inactive Counselors. Also, the precise view
          of head counselors such as Name, Address, Email, contact, and status can be seen here along with the graphs
          that show Counselor wise admission analytics and Counselor's session wise sharing percentage.<br />
          They are added and assigned institutions by the admins or head counselor. Wondering how? Let’s see
        </p>
        <h2 class="text-2xl font-semibold mb-4">How to Add a Counselor?</h2>
        <ol class="list-decimal text-lg pl-2 mb-4">
          <li> Click on the tab Add available only for Admins and head counselors</li>
          <li>Fill out the details including Name, Username, Address, Email, and Contact, and assign institute</li>
          <li>Click on Submit available at the lower right corner and lock the information.</li>
          <li>To change or make corrections, click on the Reset tab available at the lower left corner</li>
        </ol>
      </div>

      <div *ngIf="activeTab === 'sub-tab27'" class="animate-fade-in">
        <h2 class="text-2xl font-semibold mb-4">How to update the counselor’s details?</h2>
        <p class="text-justify text-lg mb-4">Once, the counselor’s details are added successfully, they will be visible
          in the List section automatically from where the User can edit or update the details easily.</p>
        <h2 class="text-2xl font-semibold mb-4">To update the counselor's details</h2>
        <ol class="list-decimal text-lg pl-2 mb-4">
          <li>Click on the edit key available in the counselor’s row</li>
          <li>Fill out the details required</li>
          <li>Click on submit and save the information</li>
        </ol>
      </div>

      <div *ngIf="activeTab === 'sub-tab28'" class="animate-fade-in">
        <h2 class="text-2xl font-semibold mb-4">How to delete or mark the status of a counselor?</h2>
        <p class="text-justify text-lg mb-4">Admin and head counselors have the authority to delete the counselor or
          mark their status as Active or Inactive.
        </p>
        <ol class="list-decimal text-lg pl-2 mb-4">
          <li>Click on the Bin key (For delete) or Lock key (Status – Active or Inactive) available in the counselor’s
            row
          </li>
          <li>Save the information</li>
        </ol>
      </div>

      <div *ngIf="activeTab === 'sub-tab29'" class="animate-fade-in">
        <h2 class="text-2xl font-semibold mb-4">How to Assign Institute to the Counselor?</h2>
        <ol class="list-decimal text-lg pl-2 mb-4">
          <li>Click on Assign Institutions tab available in the row</li>
          <li>Choose the institutions for the counselor from the list created already</li>
        </ol>
      </div>

      <div *ngIf="activeTab === 'sub-tab30'" class="animate-fade-in">
        <h2 class="text-2xl font-semibold mb-4">Is counselor can change the password?</h2>
        <p class="text-justify text-lg mb-4">Yes, by following the below-mentioned simple steps, the counselors or head
          counselor can change or create a new password.
        </p>
        <ol class="list-decimal text-lg pl-2 mb-4">
          <li>Go to the key tab and click</li>
          <li>Fill out the new password and save the information</li>
        </ol>
      </div>

      <div *ngIf="activeTab === 'sub-tab31'" class="animate-fade-in">
        <h2 class="text-2xl font-semibold mb-4">How to check the sharing percentage?</h2>
        <p class="text-justify text-lg mb-4">Through the tab Sharing, the user or Admin can check the amount of
          commission available for admission to the counselor.
        </p>
        <ol class="list-decimal text-lg pl-2 mb-4">
          <li> Click on Sharing% tab</li>
          <li>The details about the amount can be seen along with the status as pending or assigned</li>
        </ol>
      </div>

      <div *ngIf="activeTab === 'sub-tab32'" class="animate-fade-in">
        <h2 class="text-2xl font-semibold mb-4">How to see overall sharing%?</h2>
        <p class="text-justify text-lg mb-4">The wallet amount for head counselors can be added by Admins. Moreover,
          Admins can allow the enrollment sharing% to the head counselors via two methods; Overall sharing and fee
          structure sharing
        </p>
        <p class="text-justify text-lg"><span class="font-semibold">Overall Sharing:</span>The term refers to the lump
          sum amount assigned by the Admins for the student enrollment to the counselors.</p>
        <p class="text-justify text-lg mb-4"><span class="font-semibold">Fee Structure:</span>The term describes the
          commission for admission following each step mentioned- below to the counselor by admins.</p>
        <ol class="list-decimal text-lg pl-2 mb-4">
          <li>Click on the sharing tab mentioned in the counselor row</li>
          <li>Fill out the details such as including fee structure, registration fee, course fee, re-registration fee,
            and click on Assign sharing.
          </li>
        </ol>
      </div>

      <div *ngIf="activeTab === 'sub-tab33'" class="animate-fade-in">
        <h2 class="text-2xl font-semibold mb-4">How to search for a particular counselor detail?</h2>
        <p class="text-justify text-lg mb-4">If you wish to check the details for a particular counselor, the search tab
          will help you to customize the information. Check out how.</p>
        <ol class="list-decimal text-lg pl-2 mb-4">
          <li> Choose the institute or session with the filter available at the upper right corner</li>
          <li> Fill in the detail’s Program/Course/branch</li>
          <li>Click on the Search tab and see the personalized information</li>
        </ol>
      </div>

      <div *ngIf="activeTab === 'sub-tab34'" class="animate-fade-in">
        <h2 class="text-2xl font-semibold mb-4">Modules</h2>
        <p class="text-justify text-lg mb-4">Modules are distinct functional sections that collectively handle various
          aspects of managing admissions within an institution. Admin can easily Add and update programs, courses, and
          branches. Wondering how? Let’s see
          <br />
          The user or Admin will have a precise view of total programs, total courses, total branches, and total IPCB
          mappings. Additionally, Branch wise admission, course wise admissions, and program wise admission analytics
          can be seen here.
        </p>
        <p class="text-justify text-lg mb-4"><span class="font-semibold">Program:</span>Manage information related to
          the academic programs offered by the institution. For instance, an MBA is a Post Graduate Program.
          <br />
          To go through the programs list, the user needs to choose the institute to customize the relevant information.
          Fill out the details including program name/ program short name/status, and click on the search tab available
          at the upper right corner to see the information. From here, the user can add, edit, and delete the program.
          Check how!
        </p>
        <h2 class="text-2xl font-semibold mb-4">How to Add a program?</h2>
        <ol class="list-decimal text-lg pl-2 mb-4">
          <li>Click on the Add tab available at the upper right corner</li>
          <li>Choose the institute from the scroller, fill in the program name, and short name</li>
          <li>Click on submit to save the information and close the window if you do not make the changes.</li>
        </ol>
        <h2 class="text-2xl font-semibold mb-4">How to update the program?</h2>
        <ol class="list-decimal text-lg pl-2 mb-4">
          <li>Click on the edit key available in the program’s row</li>
          <li>Fill out the details and submit the information</li>
        </ol>
        <h2 class="text-2xl font-semibold mb-4">How to Mark the status?</h2>
        <ol class="list-decimal text-lg pl-2 mb-4">
          <li>Click on the Lock key available in the program’s row</li>
          <li> Click to make the status as active or inactive</li>
        </ol>
        <h2 class="text-2xl font-semibold mb-4">How to delete the program?</h2>
        <ol class="list-decimal text-lg pl-2 mb-4">
          <li>Click on the Bin tab and remove the program permanently</li>
        </ol>
        <p class="text-md mb-4 text-justify">
          <span class="text-bold"> Note:  </span> If the organization wants to delete or inactive any institute, that
          particular institute should not have active head counselors, counselors, and students.
        </p>
      </div>

      <div *ngIf="activeTab === 'sub-tab35'" class="animate-fade-in">
        <p class="text-justify text-lg mb-4"><span class="font-semibold">Courses:</span>Handles information related to
          each program's individual courses. For instance, an MBA in Finance and Accounts is a course.
          To go through the courses list, the user needs to choose the institute to customize the relevant information.
          Fill out the details including course name/ course short name/status, and click on the search tab available at
          the upper right corner to see the information. From here, the user can add, edit, and delete the course. Check
          how!
        </p>
        <h2 class="text-2xl font-semibold mb-4">How to Add a Course?</h2>
        <ol class="list-decimal text-lg pl-2 mb-4">
          <li>Click on the Add tab available at the upper right corner</li>
          <li>Choose the institute from the scroller, fill in the course name, and short name</li>
          <li>Click on submit to save the information and close the window if you do not make the changes.</li>
        </ol>
        <h2 class="text-2xl font-semibold mb-4">How to update the course?</h2>
        <ol class="list-decimal text-lg pl-2 mb-4">
          <li>Click on the edit key available in the course’s row</li>
          <li>Fill out the details and submit the information</li>
        </ol>
        <h2 class="text-2xl font-semibold mb-4">How to Mark the status?</h2>
        <ol class="list-decimal text-lg pl-2 mb-4">
          <li>Click on the Lock key available in the course’s row</li>
          <li>Click to make the status as active or inactive</li>
        </ol>
        <h2 class="text-2xl font-semibold mb-4">How to delete the course?</h2>
        <ol class="list-decimal text-lg pl-2 mb-4">
          <li>Click on the Bin tab and remove the course permanently</li>
        </ol>
        <p class="text-md mb-4 text-justify">
          <span class="text-bold"> Note:</span> Before deleting or inactive the course, please ensure that there are no
          active students.
        </p>
      </div>

      <div *ngIf="activeTab === 'sub-tab36'" class="animate-fade-in">
        <p class="text-justify text-lg mb-4"><span class="font-semibold">Branches:</span>Manages and oversees
          information about different branches of the courses. For Instance, an MBA in Finance and Accounts comes under
          Financial Management.
          <br />
          To go through the Branch’s list, the user needs to choose the institute to customize the relevant information.
          Fill out the details including Branch name/ Branch short name/status, and click on the search tab available at
          the upper right corner to see the information. From here, the user can add, edit, and delete the Branch. Check
          how!
        </p>
        <h2 class="text-2xl font-semibold mb-4">How to Add a Branch?</h2>
        <ol class="list-decimal text-lg pl-2 mb-4">
          <li>Click on the Add tab available at the upper right corner</li>
          <li>Choose the institute from the scroller, fill in the Branch name, and short name</li>
          <li>Click on submit to save the information and close the window if you do not make the changes.</li>
        </ol>
        <h2 class="text-2xl font-semibold mb-4">How to update the Branch?</h2>
        <ol class="list-decimal text-lg pl-2 mb-4">
          <li>Click on the edit key available in the Branch’s row</li>
          <li>Fill out the details and submit the information</li>
        </ol>
        <h2 class="text-2xl font-semibold mb-4">How to Mark the status?</h2>
        <ol class="list-decimal text-lg pl-2 mb-4">
          <li>Click on the Lock key available in the Branch’s row</li>
          <li>Click to make the status as active or inactive</li>
        </ol>
        <h2 class="text-2xl font-semibold mb-4">How to delete the Branch?</h2>
        <ol class="list-decimal text-lg pl-2 mb-4">
          <li>Click on the Bin tab and remove the Branch permanently</li>
        </ol>
        <p class="text-md mb-4 text-justify">
          <span class="text-bold"> Note:</span> Before deleting or inactive the branch, please ensure that there are no
          active students.
        </p>
      </div>

      <div *ngIf="activeTab === 'sub-tab37'" class="animate-fade-in">
        <p class="text-justify text-lg mb-4"><span class="font-semibold">Mappings:</span>Mapping creates relationships
          between Programs, Courses, and Branches within the institution. Here, the Admin can view the precise details
          of the programs, courses, and branches available and add them as well.
          <br />
          To go through the Mapping list, the user needs to choose the institute to customize the relevant information.
          Fill out the details including program name/ course name/branch name, and click on the search tab available at
          the upper right corner to see the information. From here, the user can add, edit, and delete the Mapping.
          Check how!
        </p>
        <h2 class="text-2xl font-semibold mb-4">How to Add a Mapping?</h2>
        <ol class="list-decimal text-lg pl-2 mb-4">
          <li>Click on the Add tab available at the upper right corner</li>
          <li>Choose the institute from the scroller, fill in the program/course/branch name</li>
          <li> Click on submit to save the information and close the window if you do not make the changes.</li>
        </ol>
        <p class="text-md mb-4 text-justify">
          <span class="text-bold"> Note:</span>The same IPCB mapping can not be made.</p>
        <h2 class="text-2xl font-semibold mb-4">How to add Fee structure?</h2>
        <p class="text-justify font-bold text-lg">The fee structure consists of the details to create the cost of the
          course or program. The admin can add
          numerous charges applicable.</p>
        <ol class="list-decimal text-lg pl-2 mb-4">
          <li>Click on Add a Fee Structure</li>
          <li>Fill out the details such as sessions, course fee, registration amount, credit transfer fee, etc.</li>
          <li> Submit the information for future use</li>
        </ol>
        <p class="text-md mb-4 text-justify">
          <span class="text-bold"> Note:</span>Without a fee structure, students can’t be assigned to the program,
          course, or branch.
        </p>
        <h2 class="text-2xl font-semibold mb-4">How to update the Mapping?</h2>
        <ol class="list-decimal text-lg pl-2 mb-4">
          <li>Click on the edit key available in the Mapping’s row</li>
          <li>Fill out the details and submit the information</li>
        </ol>
        <h2 class="text-2xl font-semibold mb-4">How to Mark the status?</h2>
        <ol class="list-decimal text-lg pl-2 mb-4">
          <li> Click on the Lock key available in the Mapping’s row</li>
          <li>Click to make the status as active or inactive</li>
        </ol>
        <h2 class="text-2xl font-semibold mb-4">How to delete the Mapping?</h2>
        <ol class="list-decimal text-lg pl-2 mb-4">
          <li>Click on the Bin tab and remove the Mapping permanently</li>
        </ol>
        <p class="text-md mb-4 text-justify">
          <span class="text-bold"> Note:</span> Please ensure that there are no students in the IPCB mapping to delete
          or inactive.
        </p>
      </div>

      <div *ngIf="activeTab === 'sub-tab37'" class="animate-fade-in">
        <p class="text-justify text-lg mb-4"><span class="font-semibold">Mappings:</span>Mapping creates relationships
          between Programs, Courses, and Branches within the institution. Here, the Admin can view the precise details
          of the programs, courses, and branches available and add them as well.
          <br />
          To go through the Mapping list, the user needs to choose the institute to customize the relevant information.
          Fill out the details including program name/ course name/branch name, and click on the search tab available at
          the upper right corner to see the information. From here, the user can add, edit, and delete the Mapping.
          Check how!
        </p>
        <h2 class="text-2xl font-semibold mb-4">How to Add a Mapping?</h2>
        <ol class="list-decimal text-lg pl-2 mb-4">
          <li>Click on the Add tab available at the upper right corner</li>
          <li>Choose the institute from the scroller, fill in the program/course/branch name</li>
          <li> Click on submit to save the information and close the window if you do not make the changes.</li>
        </ol>
        <p class="text-md mb-4 text-justify">
          <span class="text-bold"> Note:</span>The same IPCB mapping can not be made.</p>
        <h2 class="text-2xl font-semibold mb-4">How to add Fee structure?</h2>
        <p class="text-justify font-bold text-lg">The fee structure consists of the details to create the cost of the
          course or program. The admin can add
          numerous charges applicable.</p>
        <ol class="list-decimal text-lg pl-2 mb-4">
          <li>Click on Add a Fee Structure</li>
          <li>Fill out the details such as sessions, course fee, registration amount, credit transfer fee, etc.</li>
          <li> Submit the information for future use</li>
        </ol>
        <p class="text-md mb-4 text-justify">
          <span class="text-bold"> Note:</span>Without a fee structure, students can’t be assigned to the program,
          course, or branch.
        </p>
        <h2 class="text-2xl font-semibold mb-4">How to update the Mapping?</h2>
        <ol class="list-decimal text-lg pl-2 mb-4">
          <li>Click on the edit key available in the Mapping’s row</li>
          <li>Fill out the details and submit the information</li>
        </ol>
        <h2 class="text-2xl font-semibold mb-4">How to Mark the status?</h2>
        <ol class="list-decimal text-lg pl-2 mb-4">
          <li> Click on the Lock key available in the Mapping’s row</li>
          <li>Click to make the status as active or inactive</li>
        </ol>
        <h2 class="text-2xl font-semibold mb-4">How to delete the Mapping?</h2>
        <ol class="list-decimal text-lg pl-2 mb-4">
          <li>Click on the Bin tab and remove the Mapping permanently</li>
        </ol>
        <p class="text-md mb-4 text-justify">
          <span class="text-bold"> Note:</span> Please ensure that there are no students in the IPCB mapping to delete
          or inactive.
        </p>
      </div>

      <div *ngIf="activeTab === 'sub-tab38'" class="animate-fade-in">
        <h2 class="text-2xl font-semibold mb-4">Phases</h2>
        <p class="text-justify text-lg mb-4">The phases section typically refers to a structured approach to managing
          the admission process and can be added by the admins. While processing enrollment, head counselors and
          counselors can use these stages and reasons to create the most updated progress in the admission process for
          the particular student.
          <br />
          While logging in as an Admin or Organization, the tab provides details such as Total Stages, Total Reasons,
          Total Active Stages, Total Active Reasons, and Total Mappings. Moreover, the user can view information on
          stage, reason, organization name, and status along with Institutional admission analytics in a precise way.
        </p>
        <p class="text-justify text-lg mb-4"><span class="font-semibold">Stages:</span>These are the distinct steps or
          phases through which an applicant progresses during the admission process. The admin can add different stages
          to justify the progress of the enrollment process. Check out the roles and workflow of the function below.
        </p>
        <h2 class="text-2xl font-semibold mb-4">How to add stages?</h2>
        <p class="text-lg text-justify mb-4">Admins have the authority to add stages through which head counselors and
          counselors can mark the stage of
          the enrollment process of the particular students.</p>
        <ol class="list-decimal text-lg pl-2 mb-4">
          <li>Click on the Add tab available at the upper right corner</li>
          <li>fill in the stage name and submit the information</li>
        </ol>
        <h2 class="text-2xl font-semibold mb-4">How to edit existing stages?</h2>
        <ol class="list-decimal text-lg pl-2 mb-4">
          <li>Click on the edit key available in the stage row</li>
          <li>Fill out the new stage or fill out the latest updates</li>
          <li>By clicking on the submit tab, the information will be saved</li>
        </ol>
        <h2 class="text-2xl font-semibold mb-4">How to delete the stages?</h2>
        <ol class="list-decimal text-lg pl-2 mb-4">
          <li>Click on the bin key available in the stage row and remove the stage permanently.</li>
        </ol>
        <p class="text-md mb-4 text-justify">
          <span class="text-bold"> Search Tab:  </span> The search tab allows the user to go through the details of a
          particular stage or student
        </p>
      </div>

      <div *ngIf="activeTab === 'sub-tab39'" class="animate-fade-in">
        <p class="text-justify text-lg mb-4"><span class="font-semibold">Reason:</span>These are the criteria or factors
          considered at each stage that influence the decision-making process. Check out the roles and workflow of the
          function below.
        </p>
        <h2 class="text-2xl font-semibold mb-4">How to add reasons?</h2>
        <p class="text-lg text-justify mb-4">Admins have the authority to add reasons through which head counselors and
          counselors can mark the reason to hold or reject the enrollment of a particular student.
        </p>
        <ol class="list-decimal text-lg pl-2 mb-4">
          <li>Click on the Add tab available in the upper right corner</li>
          <li>Fill in the stage name and submit the information</li>
        </ol>
        <h2 class="text-2xl font-semibold mb-4">How to edit existing reasons?</h2>
        <ol class="list-decimal text-lg pl-2 mb-4">
          <li>Click on the edit key available in the reason row</li>
          <li>Fill out the new stage or fill out the latest updates</li>
          <li>By clicking on the submit tab, the information will be saved</li>
        </ol>
        <h2 class="text-2xl font-semibold mb-4">How to delete the reasons?</h2>
        <ol class="list-decimal text-lg pl-2 mb-4">
          <li>Click on the bin key available in the stage row and remove the reason permanently.</li>
        </ol>
        <p class="text-md mb-4 text-justify">
          <span class="text-bold"> Search Tab: </span> The search tab allows the user to go through the details of a
          particular reason or student
        </p>
      </div>

      <div *ngIf="activeTab === 'sub-tab40'" class="animate-fade-in">
        <p class="text-justify text-lg mb-4"><span class="font-semibold">Mappings:</span>Through the Mapping tab, the
          user can be directed to complete phase details such as stage name, reason, and institute name. They can also
          edit, update, view, and delete the information
        </p>
        <p class="text-justify text-lg mb-4">The users can view the enrollment stage and reason from here and update
          them as well.</p>
        <p class="text-md mb-4 text-justify">
          <span class="text-bold">To Add: </span> Click on Add Mapping and select the stage and reason</p>
        <p class="text-md mb-4 text-justify">
          <span class="text-bold">To Update Status: </span>Mark the status as active or inactive, submit the
          information.</p>
        <p class="text-md mb-4 text-justify">
          <span class="text-bold">To Edit: </span>To edit the details and fill out the required information</p>
        <p class="text-md mb-4 text-justify">
          <span class="text-bold">To Delete: </span>Delete the mappings permanently</p>
      </div>

      <div *ngIf="activeTab === 'sub-tab41'" class="animate-fade-in">
        <h2 class="text-2xl font-semibold mb-4">Leads</h2>
        <p class="text-lg text-justify mb-4">The leads section covers potential students or applicants who have shown
          interest in enrolling or applying to the institution. Enroll allows the gathering of leads from various
          platforms under one roof and helps them convert into admissions. Admins can fetch leads from various social
          media platforms including Facebook, Instagram, and Messenger. Also, they can add manual leads and distribute
          them among the head counselors and counselors.
          <br />
          Moreover, head counselors and counselors can all have the authority to add leads manually to process
          enrollment.
          <br />
          The leads section, makes the user frequent with the latest leads generated from numerous social media
          platforms including the manual generates leads. Here, the user can view the detailed overview of Total Leads,
          Total Manual Leads, Total Google Leads, Total Facebook Leads, Total Messenger Leads, and Total Instagram
          Leads.
        </p>
        <p class="text-justify text-lg mb-4"><span class="font-semibold">Manual Leads:</span>To transform a potential
          lead into admission, Admins, head counselors, and counselors can add data manually. Here are the steps to add,
          edit, and delete the leads created manually. Follow the below-mentioned steps to create a lead.
        </p>
        <h2 class="text-2xl font-semibold mb-4">How to add leads manually?</h2>
        <ol class="list-decimal text-lg pl-2 mb-4">
          <li>Click on the Add tab mentioned in the upper right corner</li>
          <li>Fill out the required details such as student name, contact, program, courses, etc.</li>
          <li>Submit the details and the leads automatically listed under the section</li>
        </ol>
        <h2 class="text-2xl font-semibold mb-4">How to Assign Leads?</h2>
        <p class="text-lg text-justify mb-4">The leads should be assigned to the head counselor or counselor to work
          on.</p>
        <ol class="list-decimal text-lg pl-2 mb-4">
          <li> Click on the assigned tab available in the row</li>
          <li> Assign the particular lead to the head counselor or counselor</li>
        </ol>
        <h2 class="text-2xl font-semibold mb-4">How to Edit, mark status, or delete the lead?</h2>
        <p class="text-lg text-justify mb-4">The section gives the authority to edit, update, or delete the lead details
          from the software. </p>
        <p class="text-md mb-4 text-justify">
          <span class="text-bold">To Edit: </span> Click on the edit key available in the row, fill out the required
          details, and submit the information.
        </p>
        <p class="text-md mb-4 text-justify">
          <span class="text-bold">To Edit Status: </span>Click on the Lock key and mark the status as Active or Inactive
        </p>
        <p class="text-md mb-4 text-justify">
          <span class="text-bold">To Delete: </span> Click on the bin key and remove the leads permanently. </p>
        <p class="text-md mb-4 text-justify">
          <span class="text-bold">Search: </span> Fill in Name/Email/Contact and search the particular filed</p>
        <h2 class="text-2xl font-semibold mb-4">How to check student Follow-up?</h2>
        <p class="text-lg text-justify mb-4">To convert a lead, giving a proper follow-up is essential. The user or
          managers can check the student's follow-up updated by the head counselor or counselor to know the history and
          provide the best support to the applicants.
        </p>
        <ol class="list-decimal text-lg pl-2 mb-4">
          <li>Click on the tab available in the row and check the entire list of student’s follow-ups</li>
        </ol>
        <p class="text-md mb-4 text-justify">
          <span class="text-bold">Add Student Tab: </span> To add a student directly from the leads, click on Add
          Student tab
        </p>
      </div>

      <div *ngIf="activeTab === 'sub-tab42'" class="animate-fade-in">
        <p class="text-justify text-lg mb-4"><span class="font-semibold">Facebook Leads:</span>Potential queries or
          interested applicants using Facebook can be seen here. The Admin needs to Fetch Facebook leads by the fetch
          leads tab available in the upper right corner. The page displays the candidate's name, email, contact number,
          follow-ups, and action required.
        </p>
        <h2 class="text-2xl font-semibold mb-4">How to Assign Leads?</h2>
        <p class="text-lg text-justify mb-4">The leads should be assigned to the head counselor or counselor to work
          on.</p>
        <ol class="list-decimal text-lg pl-2 mb-4">
          <li> Click on the assigned tab available in the row</li>
          <li>Assign the particular lead to the head counselor or counselor</li>
        </ol>
        <h2 class="text-2xl font-semibold mb-4">How to Edit, mark status, or delete the lead?</h2>
        <p class="text-lg text-justify mb-4">The section gives the authority to edit, update, or delete the lead details
          from the software. </p>
        <p class="text-md mb-4 text-justify">
          <span class="text-bold">To Edit: </span> Click on the edit key available in the row, fill out the required
          details, and submit the information.
        </p>
        <p class="text-md mb-4 text-justify">
          <span class="text-bold">To Edit Status: </span>Click on the Lock key and mark the status as Active or Inactive
        </p>
        <p class="text-md mb-4 text-justify">
          <span class="text-bold">To Delete: </span> Click on the bin key and remove the leads permanently. </p>
        <p class="text-md mb-4 text-justify">
          <span class="text-bold">Search: </span> Fill in Name/Email/Contact and search the particular filed</p>
        <h2 class="text-2xl font-semibold mb-4">How to check student Follow-up?</h2>
        <p class="text-lg text-justify mb-4">To convert a lead, giving a proper follow-up is essential. The user or
          managers can check the student's follow-up updated by the head counselor or counselor to know the history and
          provide the best support to the applicants.
        </p>
        <ol class="list-decimal text-lg pl-2 mb-4">
          <li>Click on the tab available in the row and check the entire list of student’s follow-ups</li>
        </ol>
        <p class="text-md mb-4 text-justify">
          <span class="text-bold">Add Student Tab: </span> To add a student directly from the leads, click on Add
          Student tab
        </p>
      </div>

      <div *ngIf="activeTab === 'sub-tab43'" class="animate-fade-in">
        <p class="text-justify text-lg mb-4"><span class="font-semibold">Messenger Leads:</span>This is where you can
          view prospective questions or interested candidates using Messenger. The admin must use the fetch leads tab,
          which is located in the upper right corner, to retrieve Facebook leads. The page lists the candidate's name,
          email address, phone number, necessary actions, and follow-ups.
        </p>
        <h2 class="text-2xl font-semibold mb-4">How to Assign Leads?</h2>
        <p class="text-lg text-justify mb-4">The leads should be assigned to the head counselor or counselor to work
          on.</p>
        <ol class="list-decimal text-lg pl-2 mb-4">
          <li> Click on the assigned tab available in the row</li>
          <li>Assign the particular lead to the head counselor or counselor</li>
        </ol>
        <h2 class="text-2xl font-semibold mb-4">How to Edit, mark status, or delete the lead?</h2>
        <p class="text-lg text-justify mb-4">The section gives the authority to edit, update, or delete the lead details
          from the software. </p>
        <p class="text-md mb-4 text-justify">
          <span class="text-bold">To Edit: </span> Click on the edit key available in the row, fill out the required
          details, and submit the information.
        </p>
        <p class="text-md mb-4 text-justify">
          <span class="text-bold">To Edit Status: </span>Click on the Lock key and mark the status as Active or Inactive
        </p>
        <p class="text-md mb-4 text-justify">
          <span class="text-bold">To Delete: </span> Click on the bin key and remove the leads permanently. </p>
        <p class="text-md mb-4 text-justify">
          <span class="text-bold">Search: </span> Fill in Name/Email/Contact and search the particular filed</p>
        <h2 class="text-2xl font-semibold mb-4">How to check student Follow-up?</h2>
        <p class="text-lg text-justify mb-4">To convert a lead, giving a proper follow-up is essential. The user or
          managers can check the student's follow-up updated by the head counselor or counselor to know the history and
          provide the best support to the applicants.
        </p>
        <ol class="list-decimal text-lg pl-2 mb-4">
          <li>Click on the tab available in the row and check the entire list of student’s follow-ups</li>
        </ol>
        <p class="text-md mb-4 text-justify">
          <span class="text-bold">Add Student Tab: </span> To add a student directly from the leads, click on Add
          Student tab
        </p>
      </div>

      <div *ngIf="activeTab === 'sub-tab44'" class="animate-fade-in">
        <p class="text-justify text-lg mb-4"><span class="font-semibold">Instagram Leads:</span>THere's where you may
          use Instagram to explore potential queries or individuals who could be interested. To obtain Facebook leads,
          the administrator needs to utilize the fetch leads tab, which is situated in the upper right corner. Name,
          phone number, email address, essential tasks, and follow-ups are listed on the page for the candidate.
        </p>
        <h2 class="text-2xl font-semibold mb-4">How to Assign Leads?</h2>
        <p class="text-lg text-justify mb-4">The leads should be assigned to the head counselor or counselor to work
          on.</p>
        <ol class="list-decimal text-lg pl-2 mb-4">
          <li> Click on the assigned tab available in the row</li>
          <li>Assign the particular lead to the head counselor or counselor</li>
        </ol>
        <h2 class="text-2xl font-semibold mb-4">How to Edit, mark status, or delete the lead?</h2>
        <p class="text-lg text-justify mb-4">The section gives the authority to edit, update, or delete the lead details
          from the software. </p>
        <p class="text-md mb-4 text-justify">
          <span class="text-bold">To Edit: </span> Click on the edit key available in the row, fill out the required
          details, and submit the information.
        </p>
        <p class="text-md mb-4 text-justify">
          <span class="text-bold">To Edit Status: </span>Click on the Lock key and mark the status as Active or Inactive
        </p>
        <p class="text-md mb-4 text-justify">
          <span class="text-bold">To Delete: </span> Click on the bin key and remove the leads permanently. </p>
        <p class="text-md mb-4 text-justify">
          <span class="text-bold">Search: </span> Fill in Name/Email/Contact and search the particular filed</p>
        <h2 class="text-2xl font-semibold mb-4">How to check student Follow-up?</h2>
        <p class="text-lg text-justify mb-4">To convert a lead, giving a proper follow-up is essential. The user or
          managers can check the student's follow-up updated by the head counselor or counselor to know the history and
          provide the best support to the applicants.
        </p>
        <ol class="list-decimal text-lg pl-2 mb-4">
          <li>Click on the tab available in the row and check the entire list of student’s follow-ups</li>
        </ol>
        <p class="text-md mb-4 text-justify">
          <span class="text-bold">Add Student Tab: </span> To add a student directly from the leads, click on Add
          Student tab
        </p>
      </div>

      <div *ngIf="activeTab === 'sub-tab45'" class="animate-fade-in">
        <h2 class="text-2xl font-semibold mb-4">Report</h2>
        <p class="text-lg mb-4 text-justify">
          The Lead Source Report section contains all the data related to various social media platforms. This includes
          Lead Stages Report, Lost Leads Report, Conversion Rate Report, Lead Response Time Report, Lead Distribution
          Report, Lead Engagement Report, Lead Ageing Report, Monthly/Weekly/Daily Lead Report, and Lead Quality Report
          via selecting counselor and head counselor.
        </p>
      </div>


      <div *ngIf="activeTab === 'sub-tab46'" class="animate-fade-in">
        <h2 class="text-2xl font-semibold mb-4">Student</h2>
        <p class="text-justify mb-4 text-lg">The section is dedicated to the students who are willing to get enrolled or
          a potential lead. The head counselor and counselor can add, edit, or delete the students to create an
          effective enrollment process. However, the students can be verified by the Admins. </p>
        <p class="text-justify mb-4 text-lg">
          Here, the user will get a detailed overview of student information including Total Students, Total Verified
          Students, Total Pending Students, Total Processed Students, Total Registered Students, and Total Transferred
          Students. Additionally, the student’s name, father's name, mother's name, and course can be seen here along
          with analytics.
        </p>
        <h2 class="text-2xl font-semibold mb-4">How to Add Students?</h2>
        <p class="text-justify mb-4 text-lg"> Head counselors and counselors have the authority to add the students and
          process them for the enrollment
          process.</p>
        <ol class="list-decimal  text-lg pl-2">
          <li> Click on the Add Student tab available</li>
          <li>Fill out the student’s details including institution, Session, Program, Course, Branch, Students Name,
            Email, Contact, etc.
          </li>
          <li>Click on submit and save the information</li>
        </ol>
        <h2 class="text-2xl font-semibold mb-4">Student List- How to edit, update, or delete the student data?</h2>
        <p class="text-justify mb-4 text-lg">Once, the student information is saved successfully, the details can be
          seen under the Student List tab and can be updated or deleted as well. After adding the student, the head
          counselor or counselor should click on the tab available in the row and upload the relevant documents and
          fills process the students.
        </p>
        <ol class="list-decimal text-lg pl-2">
          <li><span class="text-bold">To Edit – </span>Click on the edit key available in the row, fill out the required
            details, and submit the information.
          </li>
          <li><span class="text-bold">To Update Status – </span>Click on the Lock key and mark the status as Active or
            Inactive
          </li>
          <li><span class="text-bold">To Delete - </span>Click on the bin key and remove the Students permanently</li>
          <li><span class="text-bold">Search -  </span>Fill in Name/Username/Contact and search the particular field. Do
            not forget to select the institute and session.
          </li>
        </ol>
      </div>
      <div *ngIf="activeTab === 'sub-tab47'" class="animate-fade-in">
        <h2 class="text-2xl font-semibold mb-4">Student Verification – </h2>
        <p class="text-justify mb-4 text-lg">Through the tab “Verify Student,” the Admin can update the student as
          verified, not verified or document pending to proceed further with the admission process. Also, one can search
          for a particular student by selecting institution, session, name, user name, and contact information.
        </p>
        <p class="text-justify mb-4 text-lg">Head counselors and counselors can use the relevant institute filter and
          session to check the status of their students as they are verified, rejected, or pending due to documents by
          Admins. For this, they can use the search tab in the upper right corner and choose them from the scroller.
        </p>
      </div>
      <div *ngIf="activeTab === 'sub-tab48'" class="animate-fade-in">
        <h2 class="text-2xl font-semibold mb-4">Process Students - </h2>
        <p class="text-justify mb-4 text-lg">The section provides detailed information about the students processed and
          this can be done by head counselors. The user can edit, update, cancel, or view the details.
        </p>
        <ol class="list-decimal text-lg pl-2">
          <li><span class="text-bold">To Edit – </span>Click on the edit key available in the row, fill out the required
            details, and submit the information.
          </li>
          <li><span class="text-bold">To Edit Status – </span>Click on the Lock key and mark the status as Active or
            Inactive.
          </li>
          <li><span class="text-bold">To Delete - </span>Click on the bin key and remove the Students permanently.</li>
          <li><span class="text-bold">Search -  </span>Fill in Name/Username/Contact and search the particular field. Do
            not forget to select the institute and session.
          </li>
        </ol>
      </div>
      <div *ngIf="activeTab === 'sub-tab49'" class="animate-fade-in">
        <h2 class="text-2xl font-semibold mb-4">Process Counselor Students - </h2>
        <p class="text-justify mb-4 text-lg">The section provides detailed information about the student's counselor
          process. The user can edit, update, cancel, or view the details.
        </p>
        <ol class="list-decimal text-lg pl-2">
          <li><span class="text-bold">To Edit – </span>Click on the edit key available in the row, fill out the required
            details, and submit the information.
          </li>
          <li><span class="text-bold">To Edit Status – </span>Click on the Lock key and mark the status as Active or
            Inactive.
          </li>
          <li><span class="text-bold">To Delete - </span>Click on the bin key and remove the Students permanently.</li>
          <li><span class="text-bold">Search -  </span>Fill in Name/Username/Contact and search the particular field. Do
            not forget to select the institute and session.
          </li>
        </ol>
      </div>
      <div *ngIf="activeTab === 'sub-tab50'" class="animate-fade-in">
        <h2 class="text-2xl font-semibold mb-4">All Students - </h2>
        <p class="text-justify mb-4 text-lg">The section provides detailed information about all the students available.
          The authorized user can edit or delete the information as well. This section can be visible to organizations
          and admins.
        </p>
      </div>
      <div *ngIf="activeTab === 'sub-tab51'" class="animate-fade-in">
        <h2 class="text-2xl font-semibold mb-4">Accounts - </h2>
        <p class="text-justify mb-4 text-lg">The Accounts section provides a comprehensive management tool for handling
          various financial accounts associated with student admissions. It facilitates the tracking of payments,
          balances, and account settings to ensure accurate and efficient financial operations.
        </p>
        <p class="text-justify mb-4 text-lg">To track the financial reports, the user can view the transaction details
          under the tab Accounts. Here, the page provides the details such as total transactions, total transaction
          amount, total receipt, and total receipt amount. Also, one can go through the details of a particular
          counselor and session by using a filter and can see the analytics for session wise total transactions.
        </p>
        <h2 class="text-2xl font-semibold mb-4">Process Transactions: </h2>
        <p class="text-justify mb-4 text-lg">Under the tab “Process Transaction,” the user can view the account history
          of the head counselor or counselor’s transaction process status. The details contain counselor ID, Transaction
          ID, Total Amount, Total Students, and their status as Active or Inactive.
        </p>
        <p class="text-justify mb-4 text-lg">To track the details of the particular counselor or head counselor use the
          filter available in the upper right corner, fill out the details such as University name/session/amount/or
          status, and click on Search to go through the details.
        </p>
      </div>
      <div *ngIf="activeTab === 'sub-tab52'" class="animate-fade-in">
        <h2 class="text-2xl font-semibold mb-4">Receipt Transaction: </h2>
        <p class="text-justify mb-4 text-lg">Under the tab <strong>“Receipt Transaction,”</strong> the user can view the
          finance history
          of a head counselor or counselor. The details contain the Amount, Recharge Type, Transaction ID, Type, and
          their remarks.
        </p>
        <p class="text-justify mb-4 text-lg">To track the details of the particular counselor or head counselor use the
          filter available in the upper right corner, fill out the details such as University name/session/amount/or
          status, and click on <strong>Search</strong> to go through the details.
        </p>
      </div>
      <div *ngIf="activeTab === 'sub-tab53'" class="animate-fade-in">
        <h2 class="text-2xl font-semibold mb-4">Reports - </h2>
        <p class="text-justify mb-4 text-lg">Through the tab “Reports,” the user can go through the account details that
          include Account Growth Report Over the Time (can be sorted with a time filter), Daily Revenue Report (Can be
          sorted with a time filter), Account Activity Report (Can be sorted by time filter), Account Segmentation
          Report, and Churn report. The analytics for Accounts Processable Report, Payment History Report, Customer
          Lifetime Value (CLV) Report, Expense Report, Top Accounts Report, and Profitability Report. One can filter the
          result by choosing the name of the institute filter or can fetch the counselor or head counselor details.
        </p>
      </div>
      <div *ngIf="activeTab === 'sub-tab54'" class="animate-fade-in">
        <h2 class="text-2xl font-semibold mb-4">Receipt - </h2>
        <p class="text-justify mb-4 text-lg">The Receipt section of the user panel is designed to provide a
          comprehensive overview and management tool for handling financial receipts associated with student admissions.
          The Head counselors have the authority to add receipts.
        </p>
        <p class="text-justify mb-4 text-lg">The receipt section is available to go through the overview of available
          receipts that includes the total number of receipts, accepted receipts, rejected receipts, and pending
          receipts along with weekly receipts analytics.
        </p>
        <h2 class="text-2xl font-semibold mb-4">How to Add Receipt?</h2>
        <ol class="list-decimal text-lg ps-2">
          <li>Click on the Add tab available for the Head Counselor.</li>
          <li>Fill out the details including Type of receipt, Transaction ID, Date, Amount, Bank, and remarks along with
            the photo or pdf file.
          </li>
          <li>Click on submit or reset if correction is needed.</li>
        </ol>
      </div>
      <div *ngIf="activeTab === 'sub-tab55'" class="animate-fade-in">
        <h2 class="text-2xl font-semibold mb-4">List - </h2>
        <p class="text-justify mb-4 text-lg">To check the list of available receipts, click on the List tab and you can
          see the details below. To go through the particular details, use the Search Tab, choose bank/enter
          amount/select status, and click on search to check the customized information.
        </p>
      </div>
      <div *ngIf="activeTab === 'sub-tab56'" class="animate-fade-in">
        <h2 class="text-2xl font-semibold mb-4">Counselor Receipt - </h2>
        <p class="text-justify mb-4 text-lg">To check the only counselor receipt, click on the counselor receipt tab and
          get informed of the details available. To search for the particular counselor, fill out the details such as
          Bank/enter amount/select status, and click on search.
        </p>
      </div>
      <div *ngIf="activeTab === 'sub-tab57'" class="animate-fade-in">
        <h2 class="text-2xl font-semibold mb-4">Tickets - </h2>
        <p class="text-justify mb-4 text-lg">By clicking on the Tickets tab, the user can check out the status of
          available tickets. Tickets are usually created by the students, applicants, or outsiders looking to solve
          their queries related.
        </p>
        <p class="text-justify mb-4 text-lg"><strong>The overview</strong> tab offers a precise view of Admission
          Tickets, Lead Tickets,
          IVR Tickets, Other Tickets, and total tickets along with ticket count analytics by selecting the institution.
        </p>
        <h2 class="text-2xl font-semibold mb-4">Admission - </h2>
        <p class="text-justify mb-4 text-lg">All the tickets related to admission can be seen here. The user can see
          personalized details by using filters such as select institute, select session, and search by the subject or
          status of tickets.
        </p>
      </div>
      <div *ngIf="activeTab === 'sub-tab58'" class="animate-fade-in">
        <h2 class="text-2xl font-semibold mb-4">Leads - </h2>
        <p class="text-justify mb-4 text-lg">All the tickets related to lead management can be seen here. The user can
          see personalized details by using filters such as select institute, select session, and search by the subject
          or status of tickets.
        </p>
      </div>
      <div *ngIf="activeTab === 'sub-tab59'" class="animate-fade-in">
        <h2 class="text-2xl font-semibold mb-4">Others - </h2>
        <p class="text-justify mb-4 text-lg">All the tickets related to different issues can be seen here. The user can
          see personalized details by using filters such as select institute, select session, and search by the subject
          or status of tickets.
        </p>
      </div>
      <div *ngIf="activeTab === 'sub-tab60'" class="animate-fade-in">
        <h2 class="text-2xl font-semibold mb-4">Notification - </h2>
        <p class="text-justify mb-4 text-lg"><strong>The notifications</strong> tab provides the view of
          notifications/remarks updated by
          the Institute, Admin, or Head counselor.
        </p>
        <p class="text-justify mb-4 text-lg">The <strong>overview</strong> tab offers a precise view of total
          notifications, admission
          notifications, exam notifications, and head counselor notifications.
        </p>
        <h2 class="text-2xl font-semibold mb-4">How to Add Notifications?</h2>
        <p class="text-justify mb-4 text-lg">Notifications are used for internal announcements, updates, and guidance
          for the users. The institute can leave a notification for Admins, Head counselors, and counselors. Following
          the process, Admins can add notifications for the head counselor or counselor. The head counselor can also add
          notifications for the counselors.
        </p>
        <ol class="list-decimal text-lg ps-2">
          <li>Click on the Add Notification tab</li>
          <li>Choose the user as Notification for and mention the text as notification</li>
          <li>Click on submit or reset to make the changes.</li>
        </ol>
        <p class="text-justify mb-4 text-lg">Notifications are used for internal announcements, updates, and guidance
          for the users. The institute can leave a notification for Admins, Head counselors, and counselors. Following
          the process, Admins can add notifications for the head counselor or counselor. The head counselor can also add
          notifications for the counselors.
        </p>
      </div>
      <div *ngIf="activeTab === 'sub-tab61'" class="animate-fade-in">
        <h2 class="text-2xl font-semibold mb-4">Where to check my notifications?</h2>
        <p class="text-justify mb-4 text-lg">The <strong>Bell Icon</strong> button at the upper right corner close to
          the profile tab is
          showing the notifications.
        </p>
        <p class="text-justify mb-4 text-lg">Hope! The Enroll–Admission Management System provides the best support to
          the fullest transformation of your education landscape and this user guide will help you to master the various
          section and interfaces available that makes the user journey fluent.
        </p>
      </div>

    </div>
  </div>
</div>


<div class="above-footer container-fluid mt-10 md:mt-20">
  <div class="container py-12">
    <div class="m-auto text-center">
      <img src="./assets/images/img-group.png" alt="" class="mx-auto">
      <h3 class="mt-5 text-white text-xl font-medium">
        Need any further assistance?
      </h3>
      <p class="mt-4 text-white ">
        Feel free to reach out for any inquiries or assistance.
      </p>
      <button type="button" class="mt-5 px-3 py-2 bg-white text-[#6752A9] rounded" (click)="goTo('/contact-us')">
        Book an appointment now!
      </button>
    </div>
  </div>
</div>
<app-footer></app-footer>
